














import {Vue, Component, Prop} from 'vue-property-decorator';
import HistorySlider from "@/components/history/HistorySlider.vue";

export type Icon = "xmark" | "arrow-left"

@Component({
	components: {HistorySlider}
})
export default class History extends Vue {

	@Prop({default: "Change History"})
	private title!: string

	@Prop({default: "xmark"})
	private closeIcon!: Icon

	@Prop({required: true})
	private entityId!: any

	@Prop({required: true})
	private domen!: string

	@Prop({required: true})
	private schema!: any

	private model = false;
}
